/* Progressive enhancement for existing PARK FAQ sections. Answers remain native details. */
if (!customElements.get('park-help-search')) {
  customElements.define('park-help-search', class extends HTMLElement {
    connectedCallback() {
      if (this.ready) return;
      this.ready = true;
      this.scope = this.closest('main') || document;
      this.input = this.querySelector('input');
      this.original = new Map();
      this.onInput = () => this.filter();
      this.onClear = () => { this.input.value = ''; this.filter(); this.input.focus(); };
      this.onAnchor = event => {
        const a = event.target.closest('a[href^="#"]');
        if (a && this.input.value) { this.input.value = ''; this.filter(); }
      };
      this.input.addEventListener('input', this.onInput);
      this.querySelector('[data-help-clear]').addEventListener('click', this.onClear);
      this.scope.addEventListener('click', this.onAnchor);
      this.hidden = false;
      this.filter();
    }
    disconnectedCallback() {
      this.input?.removeEventListener('input', this.onInput);
      this.querySelector('[data-help-clear]')?.removeEventListener('click', this.onClear);
      this.scope?.removeEventListener('click', this.onAnchor);
      this.restore();
      this.ready = false;
    }
    normalize(value) {
      return value.toLocaleLowerCase(document.documentElement.lang || undefined).normalize('NFD').replace(/[\u0300-\u036f]/g, '').replace(/æ/g, 'ae').replace(/ø/g, 'o').replace(/[^\p{L}\p{N}]+/gu, ' ').trim();
    }
    restore() {
      this.scope?.querySelectorAll('.park-help-filter-hidden').forEach(e => e.classList.remove('park-help-filter-hidden'));
      this.original?.forEach((open, detail) => { if (detail.isConnected) detail.open = open; });
      this.original?.clear();
    }
    filter() {
      const query = this.normalize(this.input.value);
      const stop = new Set(this.normalize(this.dataset.stopWords || '').split(' ').filter(Boolean));
      let words = query.split(' ').filter(w => w && !stop.has(w));
      if (query && !words.length) words = [query];
      if (!query) this.restore();
      this.scope.querySelector('#emner')?.classList.toggle('park-help-filter-hidden', Boolean(query));
      let count = 0;
      this.scope.querySelectorAll('.park-about--faq, [data-faq-section]').forEach(section => {
        let matches = 0;
        const title = section.querySelector('h2')?.textContent || '';
        section.querySelectorAll('details.park-about__faq, details[data-faq-question]').forEach(detail => {
          const haystack = this.normalize(title + ' ' + detail.textContent);
          const found = words.every(word => haystack.includes(word));
          detail.classList.toggle('park-help-filter-hidden', !found);
          if (query) {
            if (!this.original.has(detail)) this.original.set(detail, detail.open);
            detail.open = found;
          }
          if (found) matches++;
        });
        section.classList.toggle('park-help-filter-hidden', matches === 0);
        count += matches;
      });
      this.querySelector('[data-help-results]').textContent = count + ' ' + this.dataset.resultLabel;
      this.querySelector('[data-help-empty]').hidden = !query || count > 0;
    }
  });
}
